import withUserEntity from "./../data/providers/with-user-entity";
import Entities from "./entity-component";

export default withUserEntity(Entities);
